import React, { createContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import APP_BASE_URL from "../components/Api/globalApi";
import { v4 as uuidv4 } from "uuid";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const userContext = createContext();

const AuthProvider = ({ children }) => {
	const navigate = useNavigate();
	const deviceId = uuidv4();
	const [formData, setFormData] = useState({
		device_id: deviceId,
		device_os: "1",
		device_token: "1",
		referral_id: "",
		password: "",
		app_version: "1",
	});
	const [showVideo, setShowVideo] = useState(false);
	const [user, setUser] = useState();
	const [user_dis, setuser_dis] = useState();

	const [userlogin, setUserlogin] = useState(false);

	const notify = (message) => {
		toast(message);
	};

	const AdsCount = async () => {
		try {
			const response = await axios.get(
				`${APP_BASE_URL}/vitual_mall/ads/count`,
				{}
			);

			if (response?.data?.result) {
				console.log(response.data.data, 'count')
				// setAdImages(response.data.data || []);
			} else {
				toast.error("Failed to load ads");
			}
		} catch (error) {
			console.error(error);
			toast.error("Failed to load ads");
		}
	};

	const loginSubmit = async (e) => {
		setUserlogin(true);
		e.preventDefault();

		try {
			const response = await axios.post(
				`${APP_BASE_URL}/user/login`,
				formData
			);
			console.log(formData, "referral_id");
			console.log(response, 'ijhiuiuyu');

			if (response.data.result === true) {
			setUser(response);
			setuser_dis(response.data.user_district);

			localStorage.setItem(
				"user_upgrade_date",
				response.data.user_upgrade_date
			);
			localStorage.setItem(
				"user_first_purchase",
				response.data.user_first_purchase
			);
			localStorage.setItem("purchase_status", response.data.purchase_status);
			localStorage.setItem(
				"first_purchase_amount",
				response.data.first_purchase_amount
			);
			localStorage.setItem("user_dis", response.data.user_district);
			localStorage.setItem("user_id", response.data.user_id);
			localStorage.setItem("user_api_key", response.data.user_api_key);
				AdsCount();
				const queryParams = new URLSearchParams(window.location.search);
				const redirectUrl = queryParams.get('redirect');
				if (redirectUrl) {
					navigate(redirectUrl, { state: { data: response.data, showVideo: true, mallLogin: true } });
				} else {
					navigate("/home", { state: { data: response.data, showVideo: true, mallLogin: true } });
				}
			} else {
				notify(response.data.message);
			}
		} catch (error) {
			console.error(error);
		} finally {
			setUserlogin(false);
		}
	};

	return (
		<userContext.Provider
			value={{
				formData,
				setFormData,
				loginSubmit,
				ToastContainer,
				user,
				userlogin,
				setUserlogin,
			}}
		>
			{children}
		</userContext.Provider>
	);
};

export default AuthProvider;
